import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import XtpXdpConnectionList from './containers/XtpXdpConnectionList';
import XtpXdpConnectionCreate from './containers/XtpXdpConnectionCreate';
import XtpXdpConnectionEdit from './containers/XtpXdpConnectionEdit';
import XtpXdpConnectionView from './containers/XtpXdpConnectionView';
import { SYSTEM_CONFIGURATION_ROUTE, XTP_XDP_CONNECTION, NETWORK } from '../../constants';

interface Props {
}

const XtpXdpConnection: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP_XDP_CONNECTION}`}>
        <XtpXdpConnectionList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP_XDP_CONNECTION}/create`}>
        <XtpXdpConnectionCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP_XDP_CONNECTION}/edit`}>
        <XtpXdpConnectionEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${XTP_XDP_CONNECTION}/view`}>
        <XtpXdpConnectionView />
      </Route>
    </Fragment>
  );
};

export default XtpXdpConnection;
